<template>
  <div class="markdown-body markdown">
    <VueShowdown
      class="markdown-text"
      :markdown="mdContent"
      flavor="original"
      :options="{ emoji: true }"
    />
  </div>
</template>

<script>
import { VueShowdown } from 'vue-showdown'
import 'github-markdown-css/github-markdown-light.css'

export default {
  name: 'markdownComponent',
  props: {
    md: {
      type: String,
      default: 'empty',
      required: true
    }
  },
  components: {
    VueShowdown
  },
  data () {
    return {
      mdContent: ''
    }
  },
  watch: {
    md: function (newVal, oldVal) {
      this.md = newVal === '' ? 'empty' : newVal
      this.readMdfile(this.md)
    }
  },
  mounted () {
    this.readMdfile(this.md)
  },
  methods: {
    readMdfile (md) {
      console.log('md: ', md)
      try {
        this.mdContent = require('@/assets/md/' + md + '.md')
      } catch (e) {
        this.mdContent = ''
        console.log('file not found: ', md, e)
      }
    }
  }
}
</script>

<style scoped>
.markdown {
  text-align: start;
}
.markdown-text {
  margin-left: 3vw;
  margin-right: 3vw;
}
</style>



// WEBPACK FOOTER //
// src/views/components/markdown.vue